(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jOEnk", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $e6d2018201a834b5$export$6503ec6e8aabbaf; }, function (v) { return $e6d2018201a834b5$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $e6d2018201a834b5$export$f7ad0328861e2f03; }, function (v) { return $e6d2018201a834b5$export$f7ad0328861e2f03 = v; });
var $e6d2018201a834b5$export$6503ec6e8aabbaf;
var $e6d2018201a834b5$export$f7ad0328861e2f03;
"use strict";
var $e6d2018201a834b5$var$mapping = new Map();
function $e6d2018201a834b5$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$e6d2018201a834b5$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $e6d2018201a834b5$var$resolve(id) {
    var resolved = $e6d2018201a834b5$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$e6d2018201a834b5$export$6503ec6e8aabbaf = $e6d2018201a834b5$var$register;
$e6d2018201a834b5$export$f7ad0328861e2f03 = $e6d2018201a834b5$var$resolve;

});

parcelRegister("7eix3", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $5438374b4cb52daa$export$bdfd709ae4826697; }, function (v) { return $5438374b4cb52daa$export$bdfd709ae4826697 = v; });
var $5438374b4cb52daa$export$bdfd709ae4826697;
var $5438374b4cb52daa$export$c9e73fbda7da57b6;
var $5438374b4cb52daa$export$5a759dc7a1cfb72a;
"use strict";
var $5438374b4cb52daa$var$bundleURL = {};
function $5438374b4cb52daa$var$getBundleURLCached(id) {
    var value = $5438374b4cb52daa$var$bundleURL[id];
    if (!value) {
        value = $5438374b4cb52daa$var$getBundleURL();
        $5438374b4cb52daa$var$bundleURL[id] = value;
    }
    return value;
}
function $5438374b4cb52daa$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $5438374b4cb52daa$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $5438374b4cb52daa$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $5438374b4cb52daa$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$5438374b4cb52daa$export$bdfd709ae4826697 = $5438374b4cb52daa$var$getBundleURLCached;
$5438374b4cb52daa$export$c9e73fbda7da57b6 = $5438374b4cb52daa$var$getBaseURL;
$5438374b4cb52daa$export$5a759dc7a1cfb72a = $5438374b4cb52daa$var$getOrigin;

});

var $d48912bacbf628f2$exports = {};


(parcelRequire("jOEnk")).register((parcelRequire("7eix3")).getBundleURL("99P3R"), JSON.parse('["99P3R","addons.76c13a1c.js","5s9On","menu-add-selfie.76295e13.svg","5GjYP","menu-help.e0446a39.svg"]'));


var $bNXfw = parcelRequire("bNXfw");

var $9lxLe = parcelRequire("9lxLe");
var $8fa9728faf10c188$exports = {};

$8fa9728faf10c188$exports = (parcelRequire("7eix3")).getBundleURL("99P3R") + "menu-add-selfie.76295e13.svg";


var $0dd1331d5c77eb1d$exports = {};

$0dd1331d5c77eb1d$exports = (parcelRequire("7eix3")).getBundleURL("99P3R") + "menu-help.e0446a39.svg";


(function initMenu() {
    const $menu = document.querySelector(".menu");
    const $menuList = document.querySelector(".menu__list");
    const $btnOpen = document.querySelector(".top-panel__button-menu");
    const $btnClose = document.querySelector(".menu__btn-close");
    const menuList = [
        {
            text: "Registered Faces",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8fa9728faf10c188$exports))),
            isHidden: false,
            htmlId: "selfies",
            href: (0, $9lxLe.pageRoutes).selfies
        },
        {
            text: "Terms and Conditions",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($0dd1331d5c77eb1d$exports))),
            isHidden: true,
            htmlId: "privacy-link",
            href: (0, $9lxLe.pageRoutes).privacyPolicy
        },
        {
            text: "FAQ",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($0dd1331d5c77eb1d$exports))),
            isHidden: false,
            href: (0, $9lxLe.pageRoutes).faq
        },
        {
            text: "Support",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($0dd1331d5c77eb1d$exports))),
            isHidden: true,
            htmlClass: "open-zendesk"
        }
    ];
    if ($btnOpen && $btnClose) {
        $btnOpen.addEventListener("click", ()=>{
            $menu.classList.remove("menu_hidden");
        });
        $btnClose.addEventListener("click", ()=>{
            $menu.classList.add("menu_hidden");
        });
    }
    if ($menu) {
        const template = menuList.map(({ text: text, icon: icon, isHidden: isHidden, href: href, htmlId: htmlId, htmlClass: htmlClass })=>{
            const classHidden = isHidden ? "menu__item_hidden" : "";
            const customClass = htmlClass || "";
            const attrId = htmlId ? ` id="${htmlId}"` : "";
            const attrHref = href ? ` href="${href}"` : "";
            return `
      <a class="menu__item ${classHidden} ${customClass}"${attrId}${attrHref}>
        <img class="menu__item-icon" src="${icon}" alt="" />
        <div class="menu__item-text">${text}</div>
      </a>
    `;
        });
        $menuList.innerHTML = template.join("");
    }
})();
(function initCheckbox() {
    (0, $bNXfw.onClickAll)(".checkbox", (event)=>{
        if (!(event.target.nodeName === "A")) event.currentTarget.classList.toggle("checkbox_checked");
    });
})();
(function initBackBtn() {
    (0, $bNXfw.onClickAll)(".behavior-go-back", ()=>{
        window.history.go(-1);
    });
})();
(function initBtnGoHome() {
    (0, $bNXfw.onClickAll)(".behavior-go-home", ()=>{
        window.location.href = localStorage.getItem("home");
    });
})();
(function initBtnGoToCombos() {
    (0, $bNXfw.onClickAll)(".behavior-go-combos", ()=>{
        (0, $9lxLe.redirectToPage).combos();
    });
})();

})();
//# sourceMappingURL=addons.76c13a1c.js.map
